<script>
  import options from './SchemaMarkup.options'
  export default options
</script>

<template>
  <article class="kb-schema-markup">
    <div v-if="isRestoring" class="kb-spinner-container">
      <div class="kb-spinner-container__spinner"></div>
    </div>
    <form v-else class="kb-schema-markup__form" @submit.prevent="save">
      <SchemaField v-if="nameField" :field="nameField" :depth="1" />
      <SchemaMarkupDropdown label="Type" :model-value="schema.type" @update:model-value="onTypeChange" :options="schema.typeOptions" />
      <SchemaField v-for="(field, index) in bodyFields" :key="index" :field="field" :depth="1" />
    </form>
  </article>
</template>
